module.exports = __webpack_public_path__ + "img/vertical_7_1_5012.650a804e.png";